<template>
  <div
    class="brand-logo"
    :class="[`brand-logo--${variant}`, { 'brand-logo--icon-only': !showWordmark }]"
    role="img"
    :aria-label="alt"
  >
    <img v-lazy="logoIcon" class="brand-logo-icon" alt="" aria-hidden="true" />
    <img
      v-if="showWordmark"
      v-lazy="logoWordmark"
      class="brand-logo-wordmark"
      alt=""
      aria-hidden="true"
    />
  </div>
</template>

<script setup lang="ts">
import logoIcon from "@/assets/images/letoo-ai-logo-icon.svg";
import logoWordmark from "@/assets/images/letoo-ai-logo.svg";

withDefaults(
  defineProps<{
    alt?: string;
    showWordmark?: boolean;
    variant?: "header" | "auth" | "form" | "dashboard";
  }>(),
  {
    alt: "Letoo AI",
    showWordmark: true,
    variant: "header",
  },
);
</script>

<style scoped lang="scss">
.brand-logo {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
  flex: 0 0 auto;

  img {
    display: block;
    flex: 0 0 auto;
    object-fit: contain;
  }

  &-icon {
    width: auto;
    height: 28px;
    aspect-ratio: 1;
  }

  &-wordmark {
    width: auto;
    height: 28px;
    aspect-ratio: 277 / 130;
  }

  &--header {
    gap: 0;
    max-width: 176px;
    max-height: 44px;

    .brand-logo-icon {
      height: 36px;
    }

    .brand-logo-wordmark {
      height: 44px;
    }
  }

  &--auth {
    max-width: 229px;
    max-height: 43px;

    .brand-logo-icon,
    .brand-logo-wordmark {
      height: 40px;
    }
  }

  &--form {
    max-width: 262px;
    max-height: 32px;
  }

  &--dashboard {
    max-width: 156px;
    max-height: 29px;

    .brand-logo-icon,
    .brand-logo-wordmark {
      height: 27px;
    }
  }

  &--icon-only {
    gap: 0;

    .brand-logo-icon {
      height: 32px;
    }
  }
}
</style>
